import { ProblemDetail } from '../error';

export interface ToastrConfig {
  show: boolean;
  type?: ToastrType;
  message?: string;
  problemDetail?: ProblemDetail;
  title?: string
}


export enum ToastrType {
  warning,
  error,
  success,

}
